export default __webpack_public_path__ + "static/media/cellule_film_image.64b69141.png";